//Global imports
import { useState } from 'react';

//Component imports
import { Layout } from '../../components/Layout';
import { ArticleList, CreateArticleModal } from './Components';

const Article = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleArticleCreated = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <Layout>
            <ArticleList key={refreshKey} />
            <CreateArticleModal
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                onSuccess={handleArticleCreated}
            />
        </Layout>
    );
};

export default Article;
